import { render, staticRenderFns } from "./MarketShortCard.vue?vue&type=template&id=7bb676d0&"
import script from "./MarketShortCard.vue?vue&type=script&lang=js&"
export * from "./MarketShortCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports